<main class="landing-page">

  <!-- ========================================
       HEADER
       ======================================== -->

  <header class="site-header">

    <div class="header-container">

      <a
        routerLink="/"
        class="brand"
      >
        <span class="brand-icon">
          🍽️
        </span>

        <span class="brand-name">
          Meu<span>Menu</span>
        </span>
      </a>


      <!-- MENU DESKTOP -->

      <nav class="desktop-nav">

        <a href="#recursos">
          Recursos
        </a>

        <a href="#demonstracao">
          Demonstração
        </a>

        <a href="#como-funciona">
          Como funciona
        </a>

        <a href="#resultados">
          Benefícios
        </a>

        <a href="#planos">
          Planos
        </a>

        <a
          routerLink="/login"
          class="login-link"
        >
          Entrar
        </a>

        <a
          routerLink="/register"
          class="header-cta"
        >
          Começar grátis
        </a>

      </nav>


      <!-- MENU MOBILE -->

      <button
        type="button"
        class="mobile-menu-button"
        (click)="toggleMobileMenu()"
        aria-label="Abrir menu"
      >
        ☰
      </button>

    </div>


    <nav
      class="mobile-nav"
      *ngIf="mobileMenuOpen"
    >

      <a
        href="#recursos"
        (click)="closeMobileMenu()"
      >
        Recursos
      </a>

      <a
        href="#demonstracao"
        (click)="closeMobileMenu()"
      >
        Demonstração
      </a>

      <a
        href="#como-funciona"
        (click)="closeMobileMenu()"
      >
        Como funciona
      </a>

      <a
        href="#resultados"
        (click)="closeMobileMenu()"
      >
        Benefícios
      </a>

      <a
        href="#planos"
        (click)="closeMobileMenu()"
      >
        Planos
      </a>

      <a
        routerLink="/login"
        (click)="closeMobileMenu()"
      >
        Entrar
      </a>

      <a
        routerLink="/register"
        class="mobile-nav-cta"
        (click)="closeMobileMenu()"
      >
        Começar grátis
      </a>

    </nav>

  </header>


  <!-- ========================================
       HERO
       ======================================== -->

  <section class="hero">

    <div class="hero-container">

      <!-- TEXTO -->

      <div class="hero-copy">

        <span class="hero-badge">
          ✨ Feito para restaurantes que querem vender mais
        </span>

        <h1>
          Seu restaurante mais
          <span>
            organizado, digital e lucrativo.
          </span>
        </h1>

        <p class="hero-description">
          Tenha cardápio digital, pedidos, mesas,
          QR Codes, promoções, equipe e gestão
          em uma única plataforma simples de usar.
        </p>


        <div class="hero-benefits">

          <span>
            <b>✓</b>
            Teste grátis
          </span>

          <span>
            <b>✓</b>
            Sem comissão por pedido
          </span>

          <span>
            <b>✓</b>
            Configure em poucos minutos
          </span>

        </div>


        <div class="hero-actions">

          <a
            routerLink="/register"
            class="primary-cta"
          >
            🚀 Criar meu cardápio grátis
          </a>

          <a
            href="#demonstracao"
            class="secondary-cta"
          >
            ▶ Ver o sistema funcionando
          </a>

        </div>


        <p class="hero-note">
          Não precisa instalar nada.
          Funciona direto pelo navegador.
        </p>

      </div>


      <!-- ========================================
           MOCKUP DO PRODUTO
           ======================================== -->

      <div class="hero-product">


        <!-- DASHBOARD -->

        <div class="dashboard-window">

          <div class="window-header">

            <div class="window-dots">
              <span></span>
              <span></span>
              <span></span>
            </div>

            <span class="window-url">
              app.meucardapio.com
            </span>

          </div>


          <div class="dashboard-preview">

            <aside class="preview-sidebar">

              <div class="preview-logo">
                MC
              </div>

              <span class="preview-menu active">
                📊
              </span>

              <span class="preview-menu">
                🧾
              </span>

              <span class="preview-menu">
                🍔
              </span>

              <span class="preview-menu">
                🎟️
              </span>

              <span class="preview-menu">
                💰
              </span>

            </aside>


            <div class="preview-main">

              <div class="preview-title">

                <div>
                  <small>
                    Visão geral
                  </small>

                  <strong>
                    Bom dia 👋
                  </strong>
                </div>

                <span class="preview-avatar">
                  B
                </span>

              </div>


              <div class="preview-stats">

                <div>

                  <span>
                    Pedidos hoje
                  </span>

                  <strong>
                    42
                  </strong>

                  <small>
                    ↗ +18%
                  </small>

                </div>


                <div>

                  <span>
                    Faturamento
                  </span>

                  <strong>
                    R$ 2.480
                  </strong>

                  <small>
                    ↗ crescendo
                  </small>

                </div>


                <div>

                  <span>
                    Ticket médio
                  </span>

                  <strong>
                    R$ 59
                  </strong>

                  <small>
                    últimos pedidos
                  </small>

                </div>

              </div>


              <div class="preview-chart">

                <div class="chart-header">

                  <span>
                    Pedidos na semana
                  </span>

                  <strong>
                    +24%
                  </strong>

                </div>


                <div class="fake-chart">

                  <span style="height: 38%"></span>

                  <span style="height: 57%"></span>

                  <span style="height: 47%"></span>

                  <span style="height: 78%"></span>

                  <span style="height: 65%"></span>

                  <span style="height: 92%"></span>

                  <span style="height: 80%"></span>

                </div>

              </div>

            </div>

          </div>

        </div>


        <!-- CELULAR -->

        <div class="phone-preview">

          <div class="phone-notch"></div>

          <div class="phone-content">

            <div class="phone-cover"></div>


            <div class="phone-restaurant">

              <div class="phone-logo">
                🍕
              </div>

              <div>

                <strong>
                  Pizzaria Central
                </strong>

                <small>
                  Aberto agora
                </small>

              </div>

            </div>


            <div class="phone-search">
              🔍 Buscar no cardápio
            </div>


            <div class="phone-categories">

              <span class="active">
                Pizzas
              </span>

              <span>
                Bebidas
              </span>

              <span>
                Combos
              </span>

            </div>


            <div class="phone-product">

              <span class="product-demo-image">
                🍕
              </span>

              <div>

                <strong>
                  Pizza Calabresa
                </strong>

                <small>
                  Molho, queijo e calabresa
                </small>

                <b>
                  R$ 39,90
                </b>

              </div>

              <button
                type="button"
                tabindex="-1"
              >
                +
              </button>

            </div>


            <div class="phone-product">

              <span class="product-demo-image">
                🍔
              </span>

              <div>

                <strong>
                  Combo Especial
                </strong>

                <small>
                  Hambúrguer + batata
                </small>

                <b>
                  R$ 32,90
                </b>

              </div>

              <button
                type="button"
                tabindex="-1"
              >
                +
              </button>

            </div>

          </div>

        </div>


        <!-- CARDS FLUTUANTES -->

        <div class="floating-order-card">

          <span>
            🧾
          </span>

          <div>

            <small>
              Novo pedido
            </small>

            <strong>
              Pedido #1042 recebido
            </strong>

          </div>

        </div>


        <div class="floating-growth-card">

          <span>
            📈
          </span>

          <div>

            <small>
              Vendas hoje
            </small>

            <strong>
              +18%
            </strong>

          </div>

        </div>

      </div>

    </div>

  </section>


  <!-- ========================================
       FAIXA DE CONFIANÇA
       ======================================== -->

  <section class="trust-strip">


    <div class="trust-item">

      <span>
        ⚡
      </span>

      <div>

        <strong>
          Configuração rápida
        </strong>

        <small>
          Comece em poucos minutos
        </small>

      </div>

    </div>


    <div class="trust-item">

      <span>
        🔐
      </span>

      <div>

        <strong>
          Gestão segura
        </strong>

        <small>
          Equipe e permissões
        </small>

      </div>

    </div>


    <div class="trust-item">

      <span>
        📱
      </span>

      <div>

        <strong>
          100% responsivo
        </strong>

        <small>
          Celular, tablet e PC
        </small>

      </div>

    </div>


    <div class="trust-item">

      <span>
        💬
      </span>

      <div>

        <strong>
          WhatsApp integrado
        </strong>

        <small>
          Pedido pronto para enviar
        </small>

      </div>

    </div>

  </section>


  <!-- ========================================
       ANTES E DEPOIS
       ======================================== -->

  <section
    id="resultados"
    class="transformation-section"
  >

    <div class="section-heading">

      <span class="section-eyebrow">
        MUDE A ROTINA DO SEU RESTAURANTE
      </span>

      <h2>
        Menos confusão.
        <span>
          Mais controle e vendas.
        </span>
      </h2>

      <p>
        Centralize o atendimento e deixe de depender
        de anotações, mensagens espalhadas e processos manuais.
      </p>

    </div>


    <div class="comparison-wrapper">


      <!-- ANTES -->

      <article class="comparison-card before">

        <header>

          <span>
            ✕
          </span>

          <strong>
            Antes do MeuCardápio
          </strong>

        </header>

        <ul>

          <li>
            Pedidos anotados manualmente
          </li>

          <li>
            Cardápio desatualizado em PDF
          </li>

          <li>
            Dificuldade para acompanhar pedidos
          </li>

          <li>
            Promoções divulgadas manualmente
          </li>

          <li>
            Controle de caixa separado
          </li>

          <li>
            Mesas e comandas sem integração
          </li>

        </ul>

      </article>


      <!-- DEPOIS -->

      <article class="comparison-card after">

        <header>

          <span>
            ✓
          </span>

          <strong>
            Com o MeuCardápio
          </strong>

        </header>

        <ul>

          <li>
            Pedido entra direto no painel
          </li>

          <li>
            Cardápio atualizado em tempo real
          </li>

          <li>
            Cliente acompanha o pedido
          </li>

          <li>
            Cupons e promoções configuráveis
          </li>

          <li>
            Fluxo de caixa no mesmo sistema
          </li>

          <li>
            Mesas, QR Codes e equipe integrados
          </li>

        </ul>

      </article>

    </div>


    <a
      routerLink="/register"
      class="section-cta"
    >
      Quero organizar meu restaurante →
    </a>

  </section>


  <!-- ========================================
       RECURSOS
       ======================================== -->

  <section
    id="recursos"
    class="features-section"
  >

    <div class="section-heading">

      <span class="section-eyebrow">
        UMA PLATAFORMA COMPLETA
      </span>

      <h2>
        Tudo que você precisa para
        <span>
          gerenciar e vender.
        </span>
      </h2>

      <p>
        Recursos pensados para simplificar
        a operação do restaurante.
      </p>

    </div>


    <div class="features-grid">


      <article class="feature-card highlight">

        <div class="feature-icon">
          📱
        </div>

        <span class="feature-tag">
          MAIS VENDAS
        </span>

        <h3>
          Cardápio digital profissional
        </h3>

        <p>
          Apresente seus produtos com fotos,
          categorias, preços e identidade visual
          personalizada.
        </p>

      </article>


      <article class="feature-card">

        <div class="feature-icon">
          🧾
        </div>

        <h3>
          Gestão de pedidos
        </h3>

        <p>
          Acompanhe cada pedido desde o recebimento
          até a entrega.
        </p>

      </article>


      <article class="feature-card">

        <div class="feature-icon">
          🪑
        </div>

        <h3>
          Mesas e QR Codes
        </h3>

        <p>
          Gere QR Codes individuais e organize
          o atendimento das mesas.
        </p>

      </article>


      <article class="feature-card">

        <div class="feature-icon">
          🎟️
        </div>

        <h3>
          Cupons e promoções
        </h3>

        <p>
          Crie descontos para todo o cardápio
          ou produtos específicos.
        </p>

      </article>


      <article class="feature-card">

        <div class="feature-icon">
          💰
        </div>

        <h3>
          Fluxo de caixa
        </h3>

        <p>
          Acompanhe entradas, movimentações
          e desempenho financeiro.
        </p>

      </article>


      <article class="feature-card">

        <div class="feature-icon">
          👥
        </div>

        <h3>
          Equipe e permissões
        </h3>

        <p>
          Convide funcionários e determine
          o que cada função pode acessar.
        </p>

      </article>


      <article class="feature-card">

        <div class="feature-icon">
          📊
        </div>

        <h3>
          Dashboard gerencial
        </h3>

        <p>
          Visualize indicadores e acompanhe
          a operação em um único lugar.
        </p>

      </article>


      <article class="feature-card">

        <div class="feature-icon">
          🎨
        </div>

        <h3>
          Identidade personalizada
        </h3>

        <p>
          Escolha logo, cores e imagens para
          deixar o cardápio com a cara da sua marca.
        </p>

      </article>

    </div>

  </section>


  <!-- ========================================
       DEMONSTRAÇÃO EM VÍDEO
       ======================================== -->

  <section
    id="demonstracao"
    class="demo-section"
  >

    <div class="section-heading">

      <span class="section-eyebrow">
        VEJA ANTES DE DECIDIR
      </span>

      <h2>
        Conheça o MeuCardápio
        <span>
          por dentro.
        </span>
      </h2>

      <p>
        Em poucos minutos você entende como
        cadastrar seu restaurante, montar o cardápio,
        receber pedidos e controlar sua operação.
      </p>

    </div>


    <div class="demo-container">


      <!-- VÍDEO -->

      <div class="demo-video-card">

        <div class="video-browser-bar">

          <div class="video-browser-dots">

            <span></span>

            <span></span>

            <span></span>

          </div>

          <span>
            Demonstração MeuCardápio
          </span>

        </div>


        <div class="video-wrapper">

          <!--
            Quando você publicar o vídeo no YouTube,
            troque SEU_VIDEO_ID pelo ID real.

            Exemplo:

            https://www.youtube.com/watch?v=abc123

            vira:

            https://www.youtube.com/embed/abc123
          -->

          <iframe
            src="https://www.youtube.com/embed/SEU_VIDEO_ID"
            title="Demonstração do MeuCardápio"
            loading="lazy"
            allow="
              accelerometer;
              autoplay;
              clipboard-write;
              encrypted-media;
              gyroscope;
              picture-in-picture;
              web-share
            "
            allowfullscreen
          >
          </iframe>

        </div>

      </div>


      <!-- CONTEÚDO -->

      <div class="demo-content">

        <span class="demo-label">
          EM MENOS DE 3 MINUTOS
        </span>

        <h3>
          Veja como é simples administrar
          seu restaurante.
        </h3>

        <p>
          Sem apresentações complicadas.
          Veja o sistema funcionando exatamente
          como você utilizará no dia a dia.
        </p>


        <div class="demo-features">


          <div class="demo-feature">

            <span class="demo-feature-icon">
              🍔
            </span>

            <div>

              <strong>
                Monte seu cardápio
              </strong>

              <small>
                Produtos, categorias, fotos,
                preços e disponibilidade.
              </small>

            </div>

          </div>


          <div class="demo-feature">

            <span class="demo-feature-icon">
              📱
            </span>

            <div>

              <strong>
                Veja a experiência do cliente
              </strong>

              <small>
                Cardápio responsivo,
                carrinho e pedido.
              </small>

            </div>

          </div>


          <div class="demo-feature">

            <span class="demo-feature-icon">
              🧾
            </span>

            <div>

              <strong>
                Acompanhe pedidos
              </strong>

              <small>
                Controle cada etapa pelo
                painel administrativo.
              </small>

            </div>

          </div>


          <div class="demo-feature">

            <span class="demo-feature-icon">
              🎟️
            </span>

            <div>

              <strong>
                Crie promoções
              </strong>

              <small>
                Cupons para todo o cardápio
                ou produtos específicos.
              </small>

            </div>

          </div>


          <div class="demo-feature">

            <span class="demo-feature-icon">
              🪑
            </span>

            <div>

              <strong>
                Gerencie mesas
              </strong>

              <small>
                QR Codes e atendimento integrado
                ao restaurante.
              </small>

            </div>

          </div>


          <div class="demo-feature">

            <span class="demo-feature-icon">
              📊
            </span>

            <div>

              <strong>
                Acompanhe seus números
              </strong>

              <small>
                Dashboard e fluxo de caixa
                em um único lugar.
              </small>

            </div>

          </div>

        </div>


        <a
          routerLink="/register"
          class="primary-cta demo-cta"
        >
          🚀 Quero testar gratuitamente
        </a>

      </div>

    </div>

  </section>


  <!-- ========================================
       COMO FUNCIONA
       ======================================== -->

  <section
    id="como-funciona"
    class="steps-section"
  >

    <div class="section-heading">

      <span class="section-eyebrow">
        COMEÇAR É SIMPLES
      </span>

      <h2>
        Seu cardápio no ar em
        <span>
          3 passos.
        </span>
      </h2>

      <p>
        Você não precisa entender de tecnologia
        para começar.
      </p>

    </div>


    <div class="steps-grid">


      <article>

        <span class="step-number">
          01
        </span>

        <div class="step-icon">
          🏪
        </div>

        <h3>
          Cadastre seu restaurante
        </h3>

        <p>
          Crie sua conta e informe os dados
          básicos do estabelecimento.
        </p>

      </article>


      <article>

        <span class="step-number">
          02
        </span>

        <div class="step-icon">
          🍔
        </div>

        <h3>
          Monte seu cardápio
        </h3>

        <p>
          Cadastre categorias, produtos,
          fotos, preços e promoções.
        </p>

      </article>


      <article>

        <span class="step-number">
          03
        </span>

        <div class="step-icon">
          🚀
        </div>

        <h3>
          Compartilhe e venda
        </h3>

        <p>
          Divulgue seu link ou QR Code e
          comece a receber pedidos.
        </p>

      </article>

    </div>


    <div class="steps-actions">

      <a
        routerLink="/register"
        class="primary-cta"
      >
        Criar meu cardápio grátis
      </a>

      <a
        routerLink="/cardapio/pizzaria-central"
        class="text-demo-link"
      >
        Abrir cardápio de exemplo →
      </a>

    </div>

  </section>


  <!-- ========================================
       EXPERIÊNCIA / GESTÃO
       ======================================== -->

  <section class="experience-section">


    <div class="experience-copy">

      <span class="section-eyebrow">
        FEITO PARA QUEM ESTÁ NA OPERAÇÃO
      </span>

      <h2>
        Controle seu restaurante
        <span>
          de qualquer lugar.
        </span>
      </h2>

      <p>
        Acesse pelo computador, celular ou tablet
        e acompanhe produtos, pedidos, mesas,
        promoções e equipe.
      </p>


      <div class="experience-list">

        <div>
          <span>✓</span>
          Não precisa instalar programa
        </div>

        <div>
          <span>✓</span>
          Atualizações em tempo real
        </div>

        <div>
          <span>✓</span>
          Funciona no navegador
        </div>

        <div>
          <span>✓</span>
          Interface simples para sua equipe
        </div>

      </div>


      <a
        routerLink="/register"
        class="primary-cta"
      >
        Experimentar grátis
      </a>

    </div>


    <div class="experience-panel">

      <div class="experience-dashboard">

        <div class="exp-top">

          <span>
            Visão geral
          </span>

          <strong>
            Hoje
          </strong>

        </div>


        <div class="exp-metrics">


          <div>

            <small>
              Pedidos
            </small>

            <strong>
              37
            </strong>

          </div>


          <div>

            <small>
              Em preparo
            </small>

            <strong>
              8
            </strong>

          </div>


          <div>

            <small>
              Finalizados
            </small>

            <strong>
              29
            </strong>

          </div>

        </div>


        <div class="exp-orders">


          <div>

            <span>
              #1041
            </span>

            <strong>
              Preparando
            </strong>

          </div>


          <div>

            <span>
              #1040
            </span>

            <strong>
              Pronto
            </strong>

          </div>


          <div>

            <span>
              #1039
            </span>

            <strong>
              Entregue
            </strong>

          </div>

        </div>

      </div>

    </div>

  </section>


  <!-- ========================================
       PLANOS
       ======================================== -->

  <section
    id="planos"
    class="pricing-section"
  >

    <div class="section-heading">

      <span class="section-eyebrow">
        PREÇO SIMPLES E TRANSPARENTE
      </span>

      <h2>
        Comece pequeno.
        <span>
          Cresça sem complicação.
        </span>
      </h2>

      <p>
        Teste o MeuCardápio e veja na prática
        como ele pode melhorar sua operação.
      </p>

    </div>


    <article class="main-plan">


      <div class="plan-content">

        <span class="plan-badge">
          RECOMENDADO
        </span>

        <h3>
          Plano MeuCardápio
        </h3>

        <p>
          Tudo para digitalizar seu restaurante.
        </p>


        <div class="plan-features">

          <span>
            ✓ Cardápio digital
          </span>

          <span>
            ✓ Produtos e categorias
          </span>

          <span>
            ✓ Gestão de pedidos
          </span>

          <span>
            ✓ QR Codes e mesas
          </span>

          <span>
            ✓ Cupons e promoções
          </span>

          <span>
            ✓ Dashboard
          </span>

          <span>
            ✓ Fluxo de caixa
          </span>

          <span>
            ✓ Equipe e permissões
          </span>

        </div>

      </div>


      <div class="plan-price">

        <small>
          A partir de
        </small>

        <div>

          <span>
            R$
          </span>

          <strong>
            60
          </strong>

          <small>
            /mês
          </small>

        </div>

        <p>
          Teste grátis por 7 dias.
        </p>

        <a
          routerLink="/register"
          class="pricing-button"
        >
          Começar gratuitamente
        </a>

        <span class="pricing-note">
          Sem comissão sobre seus pedidos.
        </span>

      </div>

    </article>

  </section>


  <!-- ========================================
       FAQ
       ======================================== -->

  <section class="faq-section">

    <div class="section-heading">

      <span class="section-eyebrow">
        DÚVIDAS FREQUENTES
      </span>

      <h2>
        Antes de começar,
        <span>
          talvez você queira saber.
        </span>
      </h2>

    </div>


    <div class="faq-list">


      <details>

        <summary>
          Preciso instalar algum programa?
        </summary>

        <p>
          Não. O MeuCardápio funciona pela internet
          e pode ser acessado diretamente pelo navegador.
        </p>

      </details>


      <details>

        <summary>
          Meu cliente precisa baixar aplicativo?
        </summary>

        <p>
          Não. Ele acessa seu cardápio pelo link
          ou QR Code diretamente no navegador.
        </p>

      </details>


      <details>

        <summary>
          Posso alterar meus produtos depois?
        </summary>

        <p>
          Sim. Produtos, preços, imagens, categorias
          e disponibilidade podem ser alterados
          pelo painel administrativo.
        </p>

      </details>


      <details>

        <summary>
          Posso criar promoções?
        </summary>

        <p>
          Sim. Você pode criar cupons percentuais
          ou de valor fixo e limitar a promoção
          para produtos específicos.
        </p>

      </details>


      <details>

        <summary>
          Posso ter funcionários usando o sistema?
        </summary>

        <p>
          Sim. Você pode convidar sua equipe
          e controlar as permissões de acesso
          de cada funcionário.
        </p>

      </details>


      <details>

        <summary>
          Existe comissão sobre cada pedido?
        </summary>

        <p>
          Não. O MeuCardápio não cobra comissão
          sobre os pedidos realizados pelo seu cardápio.
        </p>

      </details>


      <details>

        <summary>
          Posso testar antes de assinar?
        </summary>

        <p>
          Sim. Você pode criar sua conta e experimentar
          o sistema gratuitamente durante o período
          de teste.
        </p>

      </details>

    </div>

  </section>


  <!-- ========================================
       CTA FINAL
       ======================================== -->

  <section class="final-cta">

    <div>

      <span class="final-cta-badge">
        🚀 PRONTO PARA COMEÇAR?
      </span>

      <h2>
        Transforme seu restaurante
        sem transformar sua rotina
        em complicação.
      </h2>

      <p>
        Crie seu cardápio, organize sua operação
        e comece a vender de forma mais profissional.
      </p>


      <div class="final-actions">

        <a
          routerLink="/register"
          class="final-primary"
        >
          Criar meu cardápio grátis
        </a>

        <a
          routerLink="/cardapio/pizzaria-central"
          class="final-secondary"
        >
          Ver cardápio de exemplo
        </a>

      </div>

    </div>

  </section>


  <!-- ========================================
       FOOTER
       ======================================== -->

  <footer class="footer">

    <div class="footer-grid">


      <!-- MARCA -->

      <div class="footer-brand">

        <a
          routerLink="/"
          class="brand"
        >

          <span class="brand-icon">
            🍽️
          </span>

          <span class="brand-name">
            Meu<span>Cardápio</span>
          </span>

        </a>

        <p>
          Tecnologia simples para restaurantes
          venderem e gerenciarem melhor.
        </p>

      </div>


      <!-- PRODUTO -->

      <div>

        <strong>
          Produto
        </strong>

        <a href="#recursos">
          Recursos
        </a>

        <a href="#demonstracao">
          Demonstração
        </a>

        <a href="#planos">
          Planos
        </a>

        <a routerLink="/login">
          Entrar
        </a>

      </div>


      <!-- EMPRESA -->

      <div>

        <strong>
          Empresa
        </strong>

        <a routerLink="/termos">
          Termos de uso
        </a>

        <a routerLink="/privacidade">
          Privacidade
        </a>

      </div>


      <!-- COMEÇAR -->

      <div>

        <strong>
          Começar
        </strong>

        <a routerLink="/register">
          Criar conta
        </a>

        <a routerLink="/cardapio/pizzaria-central">
          Ver cardápio
        </a>

      </div>

    </div>


    <div class="footer-bottom">

      <span>
        © {{ currentYear }} MeuCardápio
      </span>

      <span>
        Feito para restaurantes 🍴
      </span>

    </div>

  </footer>

</main>